/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaFileBundleMiniReference,
    MediaFileBundleMiniReferenceFromJSON,
    MediaFileBundleMiniReferenceFromJSONTyped,
    MediaFileBundleMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubtitleClipboardEntry
 */
export interface SubtitleClipboardEntry {
    /**
     * 
     * @type {number}
     * @memberof SubtitleClipboardEntry
     */
    id: number;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubtitleClipboardEntry
     */
    subtitle: AssetMiniReference;
    /**
     * 
     * @type {MediaFileBundleMiniReference}
     * @memberof SubtitleClipboardEntry
     */
    bundle?: MediaFileBundleMiniReference;
    /**
     * 
     * @type {Date}
     * @memberof SubtitleClipboardEntry
     */
    readonly date: Date;
}

export function SubtitleClipboardEntryFromJSON(json: any): SubtitleClipboardEntry {
    return SubtitleClipboardEntryFromJSONTyped(json, false);
}

export function SubtitleClipboardEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubtitleClipboardEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subtitle': AssetMiniReferenceFromJSON(json['subtitle']),
        'bundle': !exists(json, 'bundle') ? undefined : MediaFileBundleMiniReferenceFromJSON(json['bundle']),
        'date': (new Date(json['date'])),
    };
}

export function SubtitleClipboardEntryToJSON(value?: SubtitleClipboardEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subtitle': AssetMiniReferenceToJSON(value.subtitle),
        'bundle': MediaFileBundleMiniReferenceToJSON(value.bundle),
    };
}


